"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.freeBetsDesktopOffers = exports.freeBetsMobileOffers = exports.attributes = exports.selectors = undefined;

var _freeze = require("babel-runtime/core-js/object/freeze");

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = exports.selectors = (0, _freeze2.default)({
	freeBetsNotifications: ".free-bets-link__notifications",
	freeBetsNotificationsNumber: ".free-bets-link__notifications-number"
});

var attributes = exports.attributes = (0, _freeze2.default)({
	dataVisible: "data-visible"
});

/**
 * This commented lines are for the mock data in case when we want
 * to mock it and we should comment the fetchDataFromAPI method
 */
var freeBetsMobileOffers = exports.freeBetsMobileOffers = (0, _freeze2.default)({
	linkUrl: "https://www.racingpost.com/free-bets/",
	numberOfOffers: 5,
	datetimeUpdated: "2024-08-23T18:30+00:00aaaa" // invalid dagetimUpdated for testing purposes
});

var freeBetsDesktopOffers = exports.freeBetsDesktopOffers = (0, _freeze2.default)({
	linkUrl: "https://www.racingpost.com/free-bets/",
	numberOfOffers: 3,
	datetimeUpdated: "2024-01-17T17:30+00:00"
});


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/bookmakersTierOne/constants.js
// module id = 1776
// module chunks = 1